import Shoe from '../pages/ShoeV3.jsx';
import Overview from '../pages/Overview.jsx';
import Quiz from '../pages/QuizV3.js';
import CouponPage from '../pages/CouponPage.jsx';
import NotificationsPage from '../pages/NotificationsPage.js';
import HowTo from '../pages/HowTo.js';
import Likes from '../pages/Likes.js';
import Discover from '../pages/Discover.js';
import Popular from '../pages/Popular.js';
import ColorwayPage from '../pages/ColorwayPage.js';
import Helper from '../functions/Helper.js';
import UserRating from '../pages/UserRating.js';
import Login from '../pages/Login.js';
import Account from '../pages/Account.js';
import Critic from '../pages/Critic.js';
import User from '../pages/User.js';
import UserReviews from '../pages/UserReviews.js';



const routes =  [
  {
    path: '\/shoe-reviews(\/.*basketball-shoes)?',
    component: Overview,
    exact:true,
    filterObject:true
  },
  /*{
    path: '/shoe-reviews/*basketball-shoes',
    component: Overview,
    exact:true,
  },*/
  {
    path: '/shoe-reviews/popular/',
    component: Popular,
    fetchToDo:"popular",
    fetchData: ()=>{
      return(fetch( __server__ + '/API/pub/popular_styles?limit=100'))
      .then((response) => response.json())
      .then((data)=>{
        return(data)
        }
      )
    }
  },
  {
    path: '/shoe-reviews/critic',
    component: Critic,
  },
  {
    path: '/shoe-reviews/user',
    component: User,
  },
  {
    path: '/shoe-reviews/quiz',
    component: Quiz,
  },
  {
    path: '/shoe-reviews/discover',
    component: Discover,
  },
  {
    path: '/shoe-reviews/coupons',
    component: CouponPage,
  },
  {
    path: '/shoe-reviews/notifications',
    component: NotificationsPage,
  },
  {
    path: '/shoe-reviews/how-does-it-work',
    component: HowTo,
  },
  {
    path: '/shoe-reviews/likes',
    component: Likes,
  },
  {
    path: '/shoe-reviews/rating',
    component: UserRating,
  },
  {
    path: '/shoe-reviews/login',
    component: Login,
  },
  {
    path: '/shoe-reviews/account',
    component: Account,
  },
  {
    path: '/shoe-reviews/user-reviews',
    component: UserReviews,
  },

  {
    path: '/shoe-reviews/:shoe_name-colorways',
    component: ColorwayPage,
    fetchToDo:"shoe",
    fetchData: (params)=>{
      return(Helper.fetchShoeData(params.shoe_name.toLowerCase()));
    }
  },

  {
    path: '/shoe-reviews/:shoe_name',
    component: Shoe,
    fetchToDo:"shoe",
    fetchData: (params)=>{
      return(Helper.fetchShoeData(params.shoe_name.toLowerCase()));
    }
  },

]
export default routes
